/* @flow */
'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var pull = require('pull-stream');
/* ::
import type {Key, Datastore, Batch, Query, QueryResult, Callback} from 'interface-datastore'
*/

/**
 * An object with a pair of functions for (invertibly) transforming keys
 */

/* ::
type KeyTransform = {
  convert: KeyMapping,
  invert: KeyMapping
}
*/

/**
 * Map one key onto another key.
 */

/* ::
type KeyMapping = (Key) => Key
*/

/**
 * A datastore shim, that wraps around a given datastore, changing
 * the way keys look to the user, for example namespacing
 * keys, reversing them, etc.
 */


var KeyTransformDatastore
/* :: <Value> */
=
/*#__PURE__*/
function () {
  /* :: child: Datastore<Value> */

  /* :: transform: KeyTransform */
  function KeyTransformDatastore(child
  /* : Datastore<Value> */
  , transform
  /* : KeyTransform */
  ) {
    _classCallCheck(this, KeyTransformDatastore);

    this.child = child;
    this.transform = transform;
  }

  _createClass(KeyTransformDatastore, [{
    key: "open",
    value: function open(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.open(callback);
    }
  }, {
    key: "put",
    value: function put(key
    /* : Key */
    , val
    /* : Value */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.put(this.transform.convert(key), val, callback);
    }
  }, {
    key: "get",
    value: function get(key
    /* : Key */
    , callback
    /* : Callback<Value> */
    )
    /* : void */
    {
      this.child.get(this.transform.convert(key), callback);
    }
  }, {
    key: "has",
    value: function has(key
    /* : Key */
    , callback
    /* : Callback<bool> */
    )
    /* : void */
    {
      this.child.has(this.transform.convert(key), callback);
    }
  }, {
    key: "delete",
    value: function _delete(key
    /* : Key */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.delete(this.transform.convert(key), callback);
    }
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Value> */
    {
      var _this = this;

      var b = this.child.batch();
      return {
        put: function put(key
        /* : Key */
        , value
        /* : Value */
        )
        /* : void */
        {
          b.put(_this.transform.convert(key), value);
        },
        delete: function _delete(key
        /* : Key */
        )
        /* : void */
        {
          b.delete(_this.transform.convert(key));
        },
        commit: function commit(callback
        /* : Callback<void> */
        )
        /* : void */
        {
          b.commit(callback);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Value> */
    )
    /* : QueryResult<Value> */
    {
      var _this2 = this;

      return pull(this.child.query(q), pull.map(function (e) {
        e.key = _this2.transform.invert(e.key);
        return e;
      }));
    }
  }, {
    key: "close",
    value: function close(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.close(callback);
    }
  }]);

  return KeyTransformDatastore;
}();

module.exports = KeyTransformDatastore;